import React from 'react'
import { Formik, Form } from 'formik'
import {
  InputField,
  InputSelectOptions,
  LoaderButton
} from 'components/molecules'
import PropTypes from 'prop-types'
import { VOUCHER_GENERATE_FLAG } from 'domains/customer-refund-voucher/constants'
const PER_PAGE = {
  10  : '10',
  25  : '25',
  50  : '50',
  100 : '100'
}

const propTypes = {
  filterValues       : PropTypes.object.isRequired,
  onClickSubmitForm  : PropTypes.func.isRequired,
  onClickReset       : PropTypes.func.isRequired,
  showCustomerFields : PropTypes.bool,
  hiddenColumns      : PropTypes.array
}

const defaultProps = {
  hiddenColumns: []
}

/**
 * Form to filters Consignment::InboundRequest data
 * @param {Object} filterValues - current url filter values
 * @param {Function} onClickSubmitForm - function to submit form
 * @param {Function} onClickReset - function to reset form
 */

const CustomerRefundVoucherFilterForm = ({
  filterValues,
  onClickSubmitForm,
  onClickReset
}) => (
  <Formik
    initialValues={{
      number   : filterValues.number || '',
      status   : filterValues.status || '',
      per_page : filterValues.per_page || 10
    }}
    enableReinitialize={ true }
    onSubmit={ onClickSubmitForm }
  >
    {
      (formikProps) => (
        <Form>
          <div className='d-flex flex-wrap mt-3'>
            <InputField
              type='text'
              name='number'
              label='Number'
              bsSize={ 'sm' }
              formGroupClassName={ 'pr-3' }
            />

            <InputField
              type='select'
              name='status'
              label='Status'
              bsSize={ 'sm' }
              formGroupClassName={ 'pr-3' }
            >
              <InputSelectOptions
                options={ VOUCHER_GENERATE_FLAG }
              />
            </InputField>

            <InputField
              type='select'
              name='per_page'
              label='Per Page'
              bsSize={ 'sm' }
              formGroupClassName='ml-auto'
            >
              <InputSelectOptions
                options={ PER_PAGE }
              />
            </InputField>
          </div>

          <LoaderButton
            color='primary'
            className='mt-auto'
            type='submit'
            disabled={ formikProps.isSubmitting }
            isLoading={ formikProps.isSubmitting }
            text='Filter'
          />
          <LoaderButton
            color='danger'
            disabled={ formikProps.isSubmitting }
            isLoading={ formikProps.isSubmitting }
            text='Reset'
            onClick={ onClickReset }
          />
        </Form>
      )
    }
  </Formik>
)

CustomerRefundVoucherFilterForm.propTypes    = propTypes
CustomerRefundVoucherFilterForm.defaultProps = defaultProps

export default CustomerRefundVoucherFilterForm
